import { Button, Form, Image, Input, InputNumber, Row } from 'antd'
import React from 'react'

import LN from 'utils/language';
import { useEffect } from 'react';
import styles from './index.module.scss'
// import { loginw,onChangeAuth} from '@/redux/actions/auth/index';
import { useDispatch } from 'react-redux';
import { login, onChangeAuth } from 'page/auth/redux'
import style from './index.module.scss'
import { useRedux } from 'redux/useRedux';
import LoginLogic from './logic';
import CustomDatePicker from 'component/DatePickerComponent/CustomDatePicker';
import { EyeHiddenIcon, EyeIcon, LoginIcon, TickIcon } from 'assets/svgComponent';
const ChangePassword = () => {
    var reg = /^[~`!@#$%^&*()_+=[\]\{}|;':",.\/<>?a-zA-Z0-9-]+$/;
    var regSymbol = /^(?:.*[!@#$%^&*()_+=]){1}/;
    const { formForget, ChangePasswordFunction } = LoginLogic()
    const { dispatch, authState } = useRedux()


    return (
        <>
            <Row align={"middle"} className={"mb30 mt50"}>
                <LoginIcon className={style.logoIcon} />
                <p className='t1 white100 ms10  '  >تغییر رمز عبور</p>
            </Row>

            <Form
                form={formForget}
                layout="vertical"
                className={["customForm"].join(" ")}
                onFinish={() => ChangePasswordFunction()}
            >

                <Row justify={"start"} className="fullWidth" style={{ minHeight: "500px" }} >
                    <Form.Item shouldUpdate>
                        {({ getFieldValue }) =>
                            <>

                                <Form.Item label={'کد ارسالی'} name="verifyCode"rules={[{ required: true, message: LN.required }, {}]}>
                                    <Input className='customInput' placeholder={'کد ارسالی'} />
                                </Form.Item>
                                
                                <Form.Item label={"رمز عبور"} name="password" rules={[{ required: true, message: LN.required }, {}]}>
                                    <Input.Password iconRender={(visible) => (!visible ? <EyeHiddenIcon /> : <EyeIcon />)} className='customInput' type={"password"} placeholder={"رمز عبور"} />
                                </Form.Item>
                                <Form.Item label={"تکرار رمز عبور"} name="confirmPassword" rules={[{ required: true, message: LN.required },
                                {
                                    validator(_, value) {
                                        if (!value || value === getFieldValue("password")) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject('رمز عبور یکسان نیست');
                                    },
                                },
                                ]}>
                                    <Input.Password iconRender={(visible) => (!visible ? <EyeHiddenIcon /> : <EyeIcon />)} className='customInput' type={"password"} placeholder={"رمز عبور"} />

                                </Form.Item>

                                <Row align={"middle"} className={"mt10 fullWidth"} >
                                    <TickIcon className={getFieldValue("password")?.length > 7 ? styles.selected : styles.notSelected} />
                                    <p className={['t5 ms10', getFieldValue("password")?.length > 7 ? 'white100' : 'white50'].join(" ")}>رمز  عبور  حداقل 8 کارکتر باشد.</p>
                                </Row>
                                <Row align={"middle"} >
                                    <TickIcon className={(reg.test(getFieldValue("password") ?? "س")) ? styles.selected : styles.notSelected} />
                                    <p className={['t5 ms10', (reg.test(getFieldValue("password") ?? "س")) ? 'white100' : 'white50'].join(" ")}>رمز عبور شامل حروف فارسی نباشد.</p>
                                </Row>
                                <Row align={"middle"} >
                                    <TickIcon className={(regSymbol.test(getFieldValue("password") ?? "")) ? styles.selected : styles.notSelected} />
                                    <p className={['t5 ms10', (regSymbol.test(getFieldValue("password") ?? "")) ? 'white100' : 'white50'].join(" ")}>{'رمز عبور درای یکی از کارکتر های ” !@#$%^&*)( “ باشد.'}</p>
                                </Row>

                                <Button className='fillButton mt30' htmlType='submit' loading={authState.changePasswordLoading} > ادامه</Button>

                                <Row justify={"center"} className={"fullWidth"} >
                                    {/* <p className='t5 white100 mt10   '  >تغییر شماره موبایل؟</p> */}
                                    <p onClick={() => dispatch(onChangeAuth("status", "forgetPassword"))} className='t5 primary mt10 ms10  pointer '  >تغییر شماره موبایل؟</p>
                                </Row>

                            </>
                        }</Form.Item>
                </Row>

            </Form>
        </>
    )
}

export default ChangePassword
